// src/utils/request.js
import axios from 'axios'

// 域名池（支持主备切换）
const DOMAIN_POOL = [
  'https://sm.appwuhui.com',
  'https://sm.taowoapp.com'
]

// 当前使用的域名索引
let currentDomainIndex = 0
// 重试计数器
let retryCount = 0
// 最大重试次数（等于域名数量）
const MAX_RETRY = DOMAIN_POOL.length

// 创建axios实例
const service = axios.create({
  baseURL: DOMAIN_POOL[currentDomainIndex],
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(config => {
  // 每次请求前更新baseURL（防止切换域名后旧请求使用旧URL）
  config.baseURL = DOMAIN_POOL[currentDomainIndex]
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 重置重试计数器
    retryCount = 0
    return response.data
  },
  async error => {
    const originalRequest = error.config
    
    // 判断是否需要重试的条件
    const shouldRetry = 
      // 网络错误
      !error.response || 
      // 5xx错误
      error.response.status < 400 ||
      // 特定超时错误码
      error.code === 'ECONNABORTED'

    if (shouldRetry && retryCount < MAX_RETRY) {
      retryCount++
      
      // 切换域名
      currentDomainIndex = (currentDomainIndex + 1) % DOMAIN_POOL.length
      console.warn(`切换到备用域名: ${DOMAIN_POOL[currentDomainIndex]}`)
      
      // 延迟1秒后重试
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      // 重试请求（使用更新后的baseURL）
      return service(originalRequest)
    }
    
    // 超过最大重试次数或不符合重试条件
    return Promise.reject(error)
  }
)

export default service